import React from 'react';
import styled from 'styled-components';
import './optionsList.css';
import PropTypes from 'prop-types';

const ButtonText = styled.span`
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
`;

const OptionsList = ({
  setChosenOption,
  options = [],
  isRequestPending,
  shouldDisplayNoOptionFoundMessage,
  shouldDisplayOptionsList,
  disableAllOptions,
  customAllOptionName = 'All Options',
  listSize = 'default',
  renderOptionActions,
}) => {
  const listClassName = `optionsList${
    listSize === 'large' ? ' optionsList--large' : ''
  }`;

  return (
    <>
      {shouldDisplayNoOptionFoundMessage && (
        <div className="optionsList__noResults">No results found</div>
      )}
      {!isRequestPending && shouldDisplayOptionsList ? (
        <ul className={listClassName}>
          {!disableAllOptions && (
            <li className="optionsList__item" key={'all_options'}>
              <button onClick={() => setChosenOption(null)}>
                <ButtonText>{customAllOptionName}</ButtonText>
              </button>
            </li>
          )}
          {options.map((option) => (
            <li
              className={`optionsList__item${
                renderOptionActions ? ' optionsList__item--withActions' : ''
              }`}
              key={option.key}
            >
              <button
                className="optionsList__itemButton"
                onClick={() => setChosenOption(option.key)}
              >
                <ButtonText>{option.label}</ButtonText>
              </button>
              {renderOptionActions && (
                <div className="optionsList__itemAction">
                  {renderOptionActions(option)}
                </div>
              )}
            </li>
          ))}
        </ul>
      ) : null}
    </>
  );
};

OptionsList.propTypes = {
  setChosenOption: PropTypes.func.isRequired,
  options: PropTypes.arrayOf(
    PropTypes.shape({
      key: PropTypes.string.isRequired,
      label: PropTypes.string.isRequired,
    })
  ).isRequired,
  isRequestPending: PropTypes.bool,
  shouldDisplayOptionsList: PropTypes.bool.isRequired,
  shouldDisplayNoOptionFoundMessage: PropTypes.bool.isRequired,
  disableAllOptions: PropTypes.bool,
  customOptionName: PropTypes.string,
  listSize: PropTypes.oneOf(['default', 'large']),
  renderOptionActions: PropTypes.func,
};

export default OptionsList;
